
export const COURSE_CONTENT_SECTION_CONFIG = {
    "basic": {
    columns: 1,
    gap: "16px",
    hideTitle: true,
  },
};

const STATUS_OPTIONS = [
    { value: "true", label: "Active" },
    { value: "false", label: "Inactive" },
];


const CONTENT_TYPE_OPTIONS = [
  { value: "VIDEO", label: "Video" },
  { value: "PDF", label: "PDF" },
  { value: "YOUTUBE_LINK", label: "YouTube Link" },
];


const CONDITIONAL_FIELD_MAP = {
    YOUTUBE_LINK: {
        name: "resourceUrl",
        label: "YouTube URL",
        type: "text",
        required: true,
        section: "basic",
    },
    VIDEO: {
        name: "file",
        label: "Upload video",
        type: "file",
        accept: "video/*", 
        required: true,
        section: "basic",
    },
    PDF: {
        name: "pdfdocument",
        label: "Upload Document",
        type: "file",
        required: true,
        accept: ".pdf",
        section: "basic",
    },
};


const BASE_FIELDS = [
    {
        name: "title",
        label: "Content Title",
        type: "text",
        required: true,
        section: "basic",
        placeholder:"Title",
    },
    {
        name: "description",
        label: "Description",
        type: "textarea",
        required: true,
        section: "basic",
        placeholder:"Desciption",
    },
    {
        name: "isActive",
        label: "Status",
        type: "select",
        required: true,
        section: "basic",
        options: STATUS_OPTIONS,
        placeholder:"Select Status",
    },
    {
        name: "contentType",
        label: "Content Type",
        type: "select",
        required: true,
        section: "basic",
        options: CONTENT_TYPE_OPTIONS,
        placeholder:"Select Type",
    },
    {
        name: "minCompletionPercentage",
        label: "Min Completion (%)",
        type: "number",
        required: true,
        section: "basic",
        placeholder:"Minimum completion",
    },
];

export const getCourseContentFields = (contentType) => {
    const conditionalField = CONDITIONAL_FIELD_MAP[contentType];
    return conditionalField ? [...BASE_FIELDS, conditionalField] : BASE_FIELDS;
};

